import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetScrapFinanceTradesHistoryService } from "@/features/accounts/scrap-finance/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetScrapFinanceTradesHistoryResponseModel } from "@/features/accounts/scrap-finance/services/get-trades-history-model";

export const useGetScrapFinanceTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getScrapFinanceTradesHistoryService = new GetScrapFinanceTradesHistoryService();

  // 銀行取込履歴取得
  const getScrapFinanceTradesHistory = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
    offset?: string,
  ): Promise<GetScrapFinanceTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getScrapFinanceTradesHistoryService.getScrapFinanceTradesHistory({
        account_group_id: accountGroupId,
        scrap_finance_account_id: financeAccountId,
        scrap_finance_id: financeId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getScrapFinanceTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getScrapFinanceTradesHistory: errorHandledAsync(getScrapFinanceTradesHistory, setError),
  };
};
